import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "label", "event", "eventLabel", "as", "onClick", "newTab", "className", "children", "aria-label", "ariaLabel"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { formatUriScheme, getOutboundLinkContainerProps } from './OutboundLink.utils';
import { Event } from '../../modules/analytics/components';
import { EventPropType } from '../../modules/analytics/types';
import { GoogleAnalytics } from '../../services/analytics';
import { ChildrenPropType } from '../../services/proptypes';
var defaultProps = {
  label: '',
  event: null,
  eventLabel: '',
  as: 'a',
  onClick: null,
  newTab: true,
  className: '',
  children: null,
  'aria-label': '',
  ariaLabel: ''
};
export default function OutboundLink(_ref) {
  var initialTo = _ref.to,
    label = _ref.label,
    event = _ref.event,
    eventLabel = _ref.eventLabel,
    as = _ref.as,
    onClickProp = _ref.onClick,
    newTab = _ref.newTab,
    className = _ref.className,
    children = _ref.children,
    ariaLabelDom = _ref['aria-label'],
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (_isEmpty(initialTo)) {
    return null;
  }
  var to = formatUriScheme(initialTo);
  function createLabel() {
    var childrenLabel = typeof children === 'string' ? children : null;
    return eventLabel || label || _get(event, 'label') || childrenLabel || to;
  }
  function sendOutboundLinkEvent() {
    GoogleAnalytics.outbound(createLabel(), {
      hitCallback: function hitCallback() {
        return null;
      }
    });
  }
  function onClick(e) {
    sendOutboundLinkEvent();
    if (onClickProp) {
      onClickProp(e);
    }
  }
  var containerProps = getOutboundLinkContainerProps(_objectSpread({
    to: to,
    label: label,
    eventLabel: eventLabel,
    newTab: newTab,
    className: className,
    onClick: onClick,
    ariaLabel: ariaLabelDom || ariaLabel
  }, rest));
  var elementProps = _objectSpread(_objectSpread({}, containerProps), {}, {
    children: children || label
  });
  var Element = /*#__PURE__*/React.createElement(as, elementProps);
  if (event) {
    return /*#__PURE__*/React.createElement(Event, {
      event: event,
      eventType: "click"
    }, Element);
  }
  return Element;
}
OutboundLink.defaultProps = defaultProps;